export const getLogoImg = (logo: string | undefined) => {
  if (logo === undefined) return undefined;
  return process.env.REACT_APP_UPLOADS + "/" + logo;
};
